/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import classNames from 'classnames';

import AIReasoningPanel from './AIReasoningPanel';

/**
 * Confidence buckets:
 *   >= 0.8  → high
 *   >= 0.5  → medium
 *   <  0.5  → low (rendered amber, surfaces a warning)
 *   null    → unknown
 */
function bucketConfidence(score) {
  if (!Number.isFinite(score)) {
    return 'unknown';
  }
  if (score >= 0.8) {
    return 'high';
  }
  if (score >= 0.5) {
    return 'medium';
  }
  return 'low';
}

const CONFIDENCE_LABELS = {
  high: 'high confidence',
  medium: 'medium confidence',
  low: 'low confidence',
  unknown: 'confidence unknown',
};

class AIMarkBadge extends Component {
  state = {
    isReasoningOpen: false,
  };

  toggleReasoning = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.setState({ isReasoningOpen: !this.state.isReasoningOpen });
  };

  closeReasoning = () => {
    this.setState({ isReasoningOpen: false });
  };

  render() {
    const { aiMark, marksAvailable } = this.props;
    if (!aiMark) {
      return null;
    }

    const status = aiMark.status;
    if (status !== 'SUCCESS') {
      return (
        <div
          data-testid="ai-mark-badge"
          className={classNames('ai-mark-badge', {
            'ai-mark-badge--pending': status === 'PENDING',
            'ai-mark-badge--failed': status === 'FAILED_NEEDS_REVIEW',
          })}
        >
          <span className="ai-mark-badge__label">AI</span>
          <span className="ai-mark-badge__status">
            {status === 'PENDING' ? 'marking…' : 'review needed'}
          </span>
        </div>
      );
    }

    const confidenceScore = Number.isFinite(aiMark.confidence_score)
      ? aiMark.confidence_score
      : aiMark.confidence_score == null
      ? null
      : parseFloat(aiMark.confidence_score);
    const bucket = bucketConfidence(confidenceScore);

    const score = Number.isFinite(aiMark.ai_score)
      ? aiMark.ai_score
      : parseInt(aiMark.ai_score, 10);
    const scoreText = `${score}/${marksAvailable}`;

    return (
      <div
        data-testid="ai-mark-badge"
        className={classNames(
          'ai-mark-badge',
          'ai-mark-badge--success',
          `ai-mark-badge--confidence-${bucket}`
        )}
      >
        <span className="ai-mark-badge__label">AI</span>
        <b className="ai-mark-badge__score">{scoreText}</b>
        <span
          className={classNames(
            'ai-mark-badge__confidence',
            `ai-mark-badge__confidence--${bucket}`
          )}
          title={CONFIDENCE_LABELS[bucket]}
        >
          {CONFIDENCE_LABELS[bucket]}
        </span>
        <button
          type="button"
          className="ai-mark-badge__view-reasoning btn-link"
          onClick={this.toggleReasoning}
        >
          View AI reasoning
        </button>
        {this.state.isReasoningOpen && (
          <AIReasoningPanel
            aiMark={aiMark}
            marksAvailable={marksAvailable}
            confidenceBucket={bucket}
            onClose={this.closeReasoning}
          />
        )}
      </div>
    );
  }
}

export default AIMarkBadge;
